"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FalconPaymentResponse {
}
exports.default = FalconPaymentResponse;
//# sourceMappingURL=FalconPaymentResponse.js.map